import axios from 'axios';
import MainLayout from "@/components/layout/MainLayout.vue";
import StarRating from "vue-star-rating";
import Pagination from "laravel-vue-pagination";
import VueSlider from "vue-slider-component";
import DatePicker from "vue2-datepicker";
import "vue-slider-component/theme/default.css";
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { mapGetters } from "vuex";
import LightBox from 'lightbox2';
import 'lightbox2/dist/css/lightbox.css';
import { ConvertNumService } from '@/assets/js/convertNumberService.js';
import moment from "moment";

const convertNumberService = new ConvertNumService();

export default {
    name: "contentGroup",
    components: {
        MainLayout,
        StarRating,
        Pagination,
        DatePicker,
        VueSlider,
        AdvancedLaravelVuePaginate,
        Loading,
        LightBox,
    },

    data() {
        return {
            classPayment: {},
            lastPage: "",
            currentPage: "",
            paymentList: true,
            class_date: '',
            class_name: '',
            payment_date:'',
            class_amount: '',
            pg_status: 0,
        }
    },
    computed: {
        ...mapGetters(["teacherId", "studentId", "userType"]),
    },

    methods: {
        paymentHistory(page = 1) {
            this.pg_status = 1;
            this.paymentList = false;
            axios.get(`/${this.userType}/payment/history?page=` + page)
                .then((response) => {
                    this.classPayment = response.data;
                    this.classPayment.total = convertNumberService.convertEng2Mm(this.classPayment.total);
                    this.lastPage = convertNumberService.convertEng2Mm(this.classPayment.last_page);
                    this.currentPage = convertNumberService.convertEng2Mm(this.classPayment.current_page);
                })
                .catch((error) => {
                    if (error.response.status == 404) {
                        this.$router.push({
                            name: 'notFound'
                        });
                    }
                    if (error.response.status == 403) {
                        this.$router.push({
                            name: 'forbidden'
                        });
                    }
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                });
        },

        getPaymentList(page = 1) {
            this.pg_status = 0;
            this.paymentList = true;
            axios.get(`/${this.userType}/payment/list?page=` + page)
                .then((response) => {
                    this.classPayment = response.data;
                    this.classPayment.total = convertNumberService.convertEng2Mm(this.classPayment.total);
                    this.lastPage = convertNumberService.convertEng2Mm(this.classPayment.last_page);
                    this.currentPage = convertNumberService.convertEng2Mm(this.classPayment.current_page);
                })
                .catch((error) => {
                    if (error.response.status == 404) {
                        this.$router.push({
                            name: 'notFound'
                        });
                    }
                    if (error.response.status == 403) {
                        this.$router.push({
                            name: 'forbidden'
                        });
                    }
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                });
        },

        downloadPaymentFile(teacherPaymentId, teacherNo) {
            axios.get(`/${this.userType}/payment/download/` + teacherPaymentId, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                responseType: 'blob' // responseType is a sibling of headers, not a child
            })
                .then(response => {
                    if (response.status == 200) {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        var currentDate = new Date();
                        const fileName = `classPayment_${teacherNo}_${currentDate.getFullYear()}${(currentDate.getMonth() + 1) > 9 ? '' : '0'}${currentDate.getMonth() + 1}${(currentDate.getDate()) > 9 ? '' : '0'}${currentDate.getDate()}.pdf`;
                        link.setAttribute('download', fileName);
                        document.body.appendChild(link);
                        link.click();
                    }
                })
                .catch(error => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    }
                })
        },

        showPaymentList(teacherPaymentId) {
            this.$router.push({
                name: "invoiceDetail",
                params: {
                    id: teacherPaymentId
                }
            });
        },

        classPaymentFilter(page = 1) {
            this.pg_status = 2;
            var request = {
                params: {
                    class_name: this.class_name,
                    class_date: this.class_date,
                    payment_date: this.payment_date,
                    class_amount: this.class_amount,
                    payment_status: this.paymentList,
                }
            }
            axios.get(`/${this.userType}/payment/filter?page=` + page, request)
                .then((response) => {
                    this.classPayment = response.data;
                    this.classPayment.total = convertNumberService.convertEng2Mm(this.classPayment.total);
                    this.lastPage = convertNumberService.convertEng2Mm(this.classPayment.last_page);
                    this.currentPage = convertNumberService.convertEng2Mm(this.classPayment.current_page);
                })
                .catch((error) => {
                    if (error.response.status == 404) {
                        this.$router.push({
                            name: 'notFound'
                        });
                    }
                    if (error.response.status == 403) {
                        this.$router.push({
                            name: 'forbidden'
                        });
                    }
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                });
        },
    },

    filters: {
        setMoment: function (date) {
            return moment(date).format("DD MMMM YYYY");
        }
    },

    mounted() {
        this.getPaymentList();
    }
};
